enum PlaybackStatus {
    BUFFERING = 'BUFFERING',
    ENDED     = 'ENDED',
    ERRORED   = 'ERRORED',
    UNLOADED  = 'UNLOADED',
    A_LOADING = 'A_LOADING',
    B_LOADING = 'B_LOADING',
    LOADED    = 'LOADED',
    PAUSED    = 'PAUSED',
    PLAYING   = 'PLAYING'
}

export default PlaybackStatus;